import axios from "@/repositories/client";

axios.getSaleStats = () => {
  let options = {
    params: {
      since: '2020-01-01',
      until: '2021-01-01'
    }
  };

  return axios.get(`athena/v1/statistics/sales`, options)
    .then(response => {
      return response.data.data;
    });
};

export default axios;
